import * as THREE from "three";
import { useMemo } from "react";
import { PRESET } from "../../lib/lighting-presets";
import { THICKNESS, Y, buildMezzanineShape } from "./shared";

export default function MezzanineFloor({ y }: { y?: number }) {
	const geo = useMemo(() => {
		const s = buildMezzanineShape();
		return new THREE.ExtrudeGeometry(s, { depth: THICKNESS, bevelEnabled: false });
	}, []);
	const py = y ?? Y;
	const floorEmissive = PRESET.mezzanine.floorEmissive;

	return (
		<mesh position={[0, py + 0.01, 0]} rotation={[Math.PI / 2, 0, 0]} frustumCulled={false} receiveShadow castShadow>
			<primitive object={geo} />
			<meshStandardMaterial color="#ff5d11" roughness={0.7} emissive="#ff5d11" emissiveIntensity={floorEmissive} />
		</mesh>
	);
}
